"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesStyles = (fields) => {
    return fields;
};
//# sourceMappingURL=createPropertiesStyles.js.map